module.exports = __webpack_public_path__ + "img/6_84.8f1c783d.png";